// src/pages/Home.jsx
import { useTranslation } from "react-i18next";
// 导入本地背景图（需将图片放在 src/assets/images/ 下）
import cityBg from "../assets/images/city-view.webp";
import HeaderBg from "../assets/images/head-bg@3x.png";
import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
} from "react";
import mVideo from "../assets/images/videoBG.mp4";
import AboutSection from "../components/AboutSection"; // 引入组件
import EquityInvestmentSection from "../components/EquityInvestmentSection"; // 引入组件

import ContactSection from "../components/ContactSection"; // 引入组件
import InvestmentPhilosophySection from "../components/InvestmentPhilosophySection"; // 引入组件

import FooterSection from "../components/FooterSection"; // 引入页脚组件
import "./Home.scss";

const Home = forwardRef((props, ref) => {
  const { t } = useTranslation();

  const sectionRefs = {
    home: useRef(null),
    about: useRef(null),
    investment: useRef(null),
    investmentFiled: useRef(null),
    csr: useRef(null),
    contact: useRef(null),
  };

  // 2. 用 useImperativeHandle 暴露 sectionRefs 给父组件
  useImperativeHandle(
    ref,
    () => ({
      sectionRefs, // 暴露区域 refs
    }),
    []
  ); // 空依赖：仅初始化一次
  const bannerStyle = {
    backgroundImage: `url(${HeaderBg})`,
  };

  document.title = t("home.company");

  const AutoPlayVideo = () => {
    // 1. 创建视频元素 ref，获取真实 DOM 节点
    const videoRef = useRef(null);

    // 2. 组件挂载后手动触发播放（核心：解决动态渲染失效问题）
    useEffect(() => {
      const video = videoRef.current;
      if (!video) return;

      // 方法1：直接尝试播放（兼容大部分场景）
      const playVideo = async () => {
        try {
          await video.play(); // 异步播放，避免报错
          console.log("视频自动播放成功");
        } catch (err) {
          console.warn("自动播放被阻止，需用户交互触发：", err);
          // 可选：添加用户交互触发播放的逻辑（如下方步骤3）
        }
      };

      playVideo();

      // 组件卸载时暂停视频（优化性能）
      return () => {
        video.pause();
      };
    }, []);
    return (
      <video
        ref={videoRef} // 绑定 ref
        src={mVideo}
        loop
        playsInline
        muted
        preload='auto' // 预加载视频，提升播放成功率
        className='video-background'
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    );
  };
  // 新增：定义滚动到 Investment Fields 的方法（传递给 AboutSection）
  const scrollToInvestmentFields = () => {
    const investmentRef = equitySectionRef.current.targetDiv;
    if (investmentRef) {
      // 平滑滚动到目标区域
      investmentRef.scrollIntoView({
        behavior: "smooth", // 平滑滚动
        block: "start", // 滚动到区域顶部
      });
    }
  };

  const equitySectionRef = useRef(null); // 用于获取 EquityInvestmentSection 内部的目标 div
  const handleBusinessCardClick = () => {
    // 功能 1：滚动到 Investment Fields
    scrollToInvestmentFields();
    // 功能 2：设置 activeFieldIndex 为 0（若状态在 Home 中）
    equitySectionRef.current.setActiveFieldIndex(0);
    // 若状态在 EquityInvestmentSection 中，可通过 ref 调用其暴露的方法，后续步骤补充
  };
  return (
    <div className='home-page anchor-target' id={t("navbar.home")}>
      {/* 城市背景图区域 */}
      <AutoPlayVideo></AutoPlayVideo>
      <div>
        {/* Hero 标语区域 */}
        <section
          ref={sectionRefs.home}
          className='hero-section'
          style={bannerStyle}
        >
          <div className='container hero-content'>
            <p className='hero-slogan sub-font'>{t("home.slogan")}</p>
            <h1 className='hero-title'>{t("home.mainTitle")}</h1>
            <p className='hero-subtitle sub-font'>{t("home.subTitle")}</p>
          </div>
        </section>
        {/* 引入 AboutSection 组件 */}
        <div style={{ height: "600px" }} ref={sectionRefs.about}></div>
        <div className='content-overlay'>
          <AboutSection onBusinessCardClick={handleBusinessCardClick} />
          {/* 股权投资区域 */}
          <div ref={sectionRefs.investment}></div>
          <EquityInvestmentSection ref={equitySectionRef} />
          {/* 投资理念区域 */}
          <div ref={sectionRefs.csr}></div>
          <InvestmentPhilosophySection />
          {/* 联系我们区域 */}
          <div id={t("navbar.contact")} ref={sectionRefs.contact}></div>
          <ContactSection ref={sectionRefs.contact} />
          {/* 页脚区域 */}
          <FooterSection />
        </div>
      </div>
    </div>
  );
});

export default Home;
